import { useState, useRef, useEffect } from "react";
import './dropdown.css'
import images from "../../assets/Icons/Icons";

interface Grade {
  classId: string;
  className: string;
}

interface Props {
  grades: any
  value: any;
  onChange?: (val: string) => void;
}

export default function GradeDropdown({
  grades,
  value,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selected = grades?.find((g:any) => g.classId === value);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className="dropdown-selected"
        onClick={() => setOpen(!open)}
      >
        <span>{selected?.className?.toUpperCase()}</span>
        <span className={`chevron ${open ? "rotate" : ""}`}>
            <img src={images.downIcon} color="black" alt="Select grade" width={15} height={15} />
        </span>
      </div>

      {open && (
        <div className="dropdown-menu">
          {grades?.map((g:any) => (
            <div
              key={g.classId}
              className="dropdown-item"
              onClick={() => {
                onChange?.(g.classId);
                setOpen(false);
              }}
            >
              {g.className}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
